<template>
    <component
        class="flex items-center justify-center px-8 py-4 transition-colors rounded-lg bg-brand-blue"
        :is="element"
        :href="href"
    >
        <slot></slot>
    </component>
</template>

<script>
export default {
    props: {
        href: {
            type: String,
            default: null,
        }
    },
    computed: {
        element: function () {
            return this.href ? 'a' : 'button';
        }
    }
}
</script>
